// EU Staging Environment Configuration
// Project: roboflow-eu-staging
// Region: europe-west1
//
// NOTE: Values marked "TODO" must be filled in after Terraform provisioning (Day 0).
// Run the bootstrap script after updating these values.

module.exports = {
    env: "staging",
    region: "eu",
    gcpRegion: "europe-west1",
    gcpProjectId: "roboflow-eu-staging",

    // Capability flags — controls which crons/integrations run in this environment
    bigQuery: { enabled: false },
    salesforce: { enabled: false },

    // Domain configuration
    urlDomain: "roboflow-eu.one",
    cookieDomain: ".roboflow-eu.one",

    // URLs
    urls: {
        app: "https://app.roboflow-eu.one",
        public: "https://public.roboflow-eu.one",
        public2: "https://public2.roboflow-eu.one",
        universe: "https://universe.roboflow-eu.one",
        rapid: "https://rapid.roboflow-eu.one",
        rapidStreamApi:
            "https://europe-west1-roboflow-eu-staging.cloudfunctions.net/rapid-v2-server",
        models: "https://models.roboflow-eu.one",
        api: "https://api.roboflow-eu.one",
        admin: "https://admin.roboflow-eu.one/",
        demo: "https://demo.roboflow-eu.one",
        upload: "upload.roboflow-eu.one",
        serverless: "https://serverless.roboflow-eu.one",
        workflowAssistant:
            "https://europe-west1-roboflow-eu-staging.cloudfunctions.net/light-v2-query",
        dedicatedDeployments: "staging.roboflow.cloud"
    },

    // Inference endpoints
    inference: {
        classification: "https://lambda-classification.staging.roboflow.eu",
        instanceSegmentation: "https://lambda-instance-segmentation.staging.roboflow.eu",
        semanticSegmentation: "https://lambda-semantic-segmentation.staging.roboflow.eu",
        objectDetection: "https://lambda-object-detection.staging.roboflow.eu",
        serverless: "https://serverless.roboflow-eu.one",
        sam: "https://smartpoly.svc.roboflow-eu.one/smartpoly/v2/inference",
        ritm: "https://smartpoly.svc.roboflow-eu.one/smartpoly/v1/inference",
        autoLabel: "https://inference-internal.roboflow-eu.one",
        owlv2: "https://inference-internal.roboflow-eu.one/owlv2/infer",
        gpuWorkflow: "https://serverless.roboflow-eu.one/workflows/run"
    },

    // Redis configuration
    redis: {
        billing: "10.209.123.164:6379",
        cache: "10.209.123.164:6379",
        flush: { host: "10.209.123.164", port: 6379 }
    },

    vpcConnector: "eu-staging-connector",

    // Spanner configuration
    spanner: { instanceId: "spanner-instance-staging" },

    // Firebase configuration
    firebase: {
        projectId: "roboflow-eu-staging",
        projectNumber: "1044450058029",
        appId: "1:1044450058029:web:9f519dc63b62745e29fda4",
        databaseURL: "https://roboflow-eu-staging.firebaseio.com",
        storageBucket: "roboflow-eu-staging-regional-sources",
        locationId: "europe-west",
        apiKey: "AIzaSyBLt5aSSniNqgVtIN4dJxc_ThnDmJU-RXs",
        authDomain: "app.roboflow-eu.one",
        messagingSenderId: "1044450058029",
        consoleUrl:
            "https://console.firebase.google.com/u/0/project/roboflow-eu-staging/firestore/data/",
        appCheckSiteKey: "TODO"
    },

    // CDN configuration
    cdn: {
        source: "source.roboflow-eu.one",
        repo: "repo.roboflow-eu.one",
        userContent: "https://usercontent.roboflow-eu.one",
        assets: "https://cdnassets.roboflow-eu.one"
    },

    // Third-party services
    // Shared with US staging
    pusher: { appId: "iy92y09b" },
    intercom: {
        // TODO: Create EU-specific instance if GDPR requires
        appId: "iy92y09b",
        sharedSupportAccountId: "7768950",
        teamIds: { growthSales: "8129885", selfServeSupport: "7809592" }
    },
    // TODO: Create EU-specific instance if GDPR requires
    customerIo: { siteId: "47e7e677319868074330" },
    segment: { frontendWriteKey: "HBZHcbQpVRUB7cA1KNGMsrGy3rhX58GL" },
    posthog: { apiKey: "phc_7vHmsEBQdrH92qV7ePSX6xxaJPEP9GrZMt557NI5ZhV" },
    reddit: { appId: "a2_gknkiaps6sl9" },
    turnServer: { urls: "turn:turn1.roboflow-eu.one:3478" },

    // BigQuery configuration
    bigQuery: {
        dataset: "roboflow_app_staging_eu",
        workspace: "roboflow-eu-staging.roboflow_app_staging_eu_server",
        universeDatasetStats:
            "roboflow-eu-staging.product_scheduled_query_results.staging_eu_universe_dataset_stats"
    },

    // Model monitoring
    modelMonitoring: { apiUrl: "TODO" },

    // Model evaluation
    modelEval: {
        dockerUri: "europe-west1-docker.pkg.dev/roboflow-eu-staging/model-eval/model-eval",
        roboflowApiUrl: "https://api.roboflow-eu.one",
        roboflowAppUrl: "https://app.roboflow-eu.one",
        objectDetectionInferenceEndpoint: "https://serverless.roboflow-eu.one",
        asyncInferenceEndpoint: "https://serverless.roboflow-eu.one"
    },

    // Buckets - keys are the aliases used by bucket() function
    buckets: {
        "train": "roboflow-eu-staging-train",
        "cache": "roboflow-eu-staging-cache",
        "sources": "roboflow-eu-staging-regional-sources",
        "exports": "roboflow-eu-staging-regional-exports",
        "transforms": "roboflow-eu-staging-regional-transforms",
        "train-resume": "roboflow-eu-staging-resume-training-files",
        "train-log": "eu-roboflow-failed-train-logs-staging",
        "data-sharing": "eu-data-sharing-staging",
        "embeddings": "roboflow-eu-staging-embeddings",
        "weights-upload": "roboflow-eu-staging-weights-upload",
        "videos": "roboflow-eu-staging-videos",
        "core-models-tfjs": "roboflow-eu-staging-core-models-tfjs",
        "usercontent": "roboflow-eu-staging-usercontent",
        "iris-input-data": "roboflow-eu-staging-rapid-upload-data", // Renamed from iris-input-data in EU
        // Internal buckets (not used via bucket() alias)
        "core-models": "roboflow-eu-staging-core-models",
        "trt-compilation": "roboflow-eu-staging-trt-compilation",
        "autodistill": "eu-com-roboflow-autodistill-staging",
        "fb-export": "roboflow-periodic-backups-eu-staging",
        "data-staging": "roboflow-eu-staging-data-staging",
        "batch-processing": "roboflow-eu-staging-batch-processing",
        "goat-models-service-recovery": "roboflow-eu-staging-model-registry-recovery"
    },

    // Cloudflare R2
    r2: { coreModelsCache: "roboflow-eu-staging-core-models-cache", endpoint: "TODO" },

    // PubSub topics
    pubsub: {
        batchProcessing:
            "projects/rf-batch-eu-staging/topics/roboflow-eu-staging-batch-processing-events",
        dataStaging: "projects/rf-batch-eu-staging/topics/roboflow-eu-staging-image-shards-uploaded"
    },

    // Device monitoring
    clickhouseDeviceMonitoring: { serviceId: "TODO" },

    // Super admins
    superAdmins: ["Wdvj1wNYH4Sz0XlYi6j8IwJLF1b2"],

    // Internal IPs
    // TODO: Add EU cluster IPs
    internalServiceIPs: [],

    // Secrets references
    modelsServiceSecretRef: "projects/1044450058029/secrets/MODELS_SERVICE_INTERNAL_SECRET",

    // Bucket mirror / sync config
    // TODO: EU may not need AWS bucket mirror initially
    bucketMirror: {
        awsAccountId: "TODO",
        gcpServiceAccount: "bucket-sync@roboflow-eu-staging.iam.gserviceaccount.com",
        audience: "roboflow-eu-staging",
        gcpAccessRoleArn: "TODO",
        adminApiRoleArn: "TODO",
        apiEndpoint: "TODO",
        apiVpcEndpoint: "TODO",
        s3VpceId: "TODO",
        s3VpceDns: "TODO"
    },

    trainClusters: {
        "goog-europe-west1": {
            k8sClusterName: "platform",
            region: "europe-west1",
            projectId: "roboflow-eu-staging",
            hasSpot: false,
            hasOndemand: true,
            timeZone: "Europe/Amsterdam",
            location: "EU",
            gpuTypes: ["l4"],
            gpuPrefer: { l4: 100 }
        }
    },

    // Image suggestions dataset
    // TODO: Need EU-specific datasets
    imageSuggestionsDataset: { workspaceId: "TODO", projectId: "TODO" },

    // COCO model reference
    // TODO: Need EU-specific model
    cocoModel: "TODO",

    // YOLO-NAS COCO models
    // TODO: Need EU-specific models
    yolonasCocoModels: {
        url: "TODO",
        name: "MS COCO",
        owner: "TODO",
        type: "object-detection",
        versions: []
    },

    // Stripe configuration (full config)
    // Shared with US staging - same Stripe test account
    stripe: {
        publishableKey: "pk_test_vDJd8VmO7HZc8B6h0jCNAptE00rSMNQP0T",
        coupons: { opencv: "TJYNN79x" },
        products: {
            sourceImage: "price_1Gvna6JRyZoEkwsrU0Xe2XTO",
            generatedImage: "price_1GvnacJRyZoEkwsrLfmh2ZI0"
        },
        starterPlan: {
            productId: "prod_NUwbi9IdrEVD0J",
            priceId: "price_1MjwhvJRyZoEkwsrP7sn14La",
            annualPriceId: "price_1MjwnLJRyZoEkwsr9YsZvir7",
            expansionProductId: "prod_NxJjjUh651goW8",
            expansionPriceId: "price_1NBP6LJRyZoEkwsri2xLnxrX",
            expansionAnnualPriceId: "price_1NDukZJRyZoEkwsr76ORtokV",
            legacyProductId: "_",
            customExpansion: {
                images: {
                    productId: "prod_OFFvyvrVWDMuUe",
                    priceId: "price_1NSlPgJRyZoEkwsrthqRynyB",
                    upsellPriceId: "price_1NSlPgJRyZoEkwsrRUF8xR9g",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 19,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                inferences: {
                    productId: "prod_OFFy3aApSb08f6",
                    priceId: "price_1NbCjQJRyZoEkwsr2FrGJQ4D",
                    upsellPriceId: "price_1NbCkhJRyZoEkwsrpBE3XMAB",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 3,
                    quantityPerUnit: 1000,
                    max: Infinity
                },
                adminCollaborators: {
                    productId: "prod_OFG2a8tc94BvSU",
                    priceId: "price_1NSlWdJRyZoEkwsrwS5BNw5C",
                    upsellPriceId: "price_1NSlWdJRyZoEkwsrHfxPUvon",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 99,
                    quantityPerUnit: 1,
                    max: Infinity
                },
                trainCredits: {
                    productId: "prod_OFG54WVsWJPdTL",
                    priceId: "price_1NijUOJRyZoEkwsrBrLCv9y5",
                    upsellPriceId: "price_1PIe4jJRyZoEkwsrz2uR9fQd",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 60,
                    quantityPerUnit: 5,
                    max: Infinity
                },
                rbac: {
                    productId: "prod_OXCwZxoB0qjdBP",
                    priceId: "price_1NkSa1JRyZoEkwsrXVXBHLZg",
                    upsellPriceId: "price_1NkTGCJRyZoEkwsrByzQMpQQ",
                    upsellDiscountPercent: 0.2,
                    pricePerUnit: 179,
                    quantityPerUnit: 1,
                    max: 1,
                    labelers: 5,
                    reviewers: 2
                }
            },
            offers: {
                oak: { priceId: "price_1OEhjHJRyZoEkwsrUxzpfSQJ", displayName: "OAK-D Lite" },
                outsourcedLabeling: {
                    priceId: "price_1OEhjuJRyZoEkwsrKDzHX4HX",
                    displayName: "Free Outsourced Labeling"
                },
                trainingCredits: {
                    priceId: "price_1OP8kxJRyZoEkwsrxzmZrSL1",
                    displayName: "30 Training Credits"
                }
            }
        },
        basicPlan: {
            productId: "prod_RCReiKt7YsfX8U",
            priceId: "price_1QKqE4JRyZoEkwsr1v90svDs",
            annualPriceId: "price_1QKqERJRyZoEkwsrQy8LVwmi"
        },
        corePlan: {
            productId: "prod_TWf0Mffe1hSmJu",
            priceId: "price_1SZbguJRyZoEkwsrDIh8zS3O",
            annualPriceId: "price_1SZbguJRyZoEkwsrwFrvvrNG",
            customExpansion: {
                adminCollaborators: {
                    productId: "prod_TX8v32dh92pWfi",
                    priceId: "price_1Sa4e7JRyZoEkwsrIo6XqBfd",
                    annualPriceId: "price_1Sc4o6JRyZoEkwsro0qEhnUr",
                    upsellDiscountPercent: 0,
                    pricePerUnit: 29,
                    quantityPerUnit: 1,
                    max: 7
                }
            }
        },
        growthPlan: {
            productId: "prod_RCRfDJ4EAIUm3P",
            priceId: "price_1QKqFQJRyZoEkwsry28Eo9MW",
            annualPriceId: "price_1QKqFoJRyZoEkwsr65fNbfP3"
        },
        autoLabel: {
            productId: "prod_Pm51cqMehMnLpF",
            default: [
                { priceId: "price_1OzN2SJRyZoEkwsrB541mZ3u", price: 15, credits: 500 },
                { priceId: "price_1OwswQJRyZoEkwsrIwbF4qIp", price: 29, credits: 1000 },
                { priceId: "price_1OwswvJRyZoEkwsrx5PyktZf", price: 129, credits: 5000 },
                { priceId: "price_1Owsx7JRyZoEkwsr5WKJkBZe", price: 249, credits: 10000 }
            ],
            starter: [
                { priceId: "price_1OwYe3JRyZoEkwsrAZDFdu3e", price: 49, credits: 2500 },
                { priceId: "price_1OwYeYJRyZoEkwsru0GLa6mL", price: 179, credits: 10000 },
                { priceId: "price_1OwYevJRyZoEkwsrOBG0vl2z", price: 349, credits: 25000 },
                { priceId: "price_1OwYf6JRyZoEkwsrWG7fYGwH", price: 599, credits: 50000 },
                { priceId: "price_1OwYfMJRyZoEkwsrOoEyGsvi", price: 999, credits: 100000 }
            ]
        },
        flexUsage: {
            hostedInferencesProductId: "prod_R0V9be1Wv6zzuW",
            hostedInferencesPriceId: "price_1Q8U9aJRyZoEkwsrhH6QEROz",
            roboflowCreditsProductId: "prod_REdfXECVONNUA0",
            roboflowCreditsMeterId: "mtr_test_61RHrroTof4RYXhyQ41JRyZoEkwsr1p2",
            roboflowPrepaidCreditsProductId: "prod_RbBSVqpryAoV3A"
        }
    },

    // Docs workspace
    docsWorkspaceId: null,

    // Sample dataset and large workspaces
    sampleDataset: null,
    largeWorkspaces: [],

    // Support config
    supportTeam: { id: null },
    supportUser: { id: null, email: "help@roboflow.com" }
};
